export default function initializeLogoSlider() {
    const sliders = document.querySelectorAll('.block-logo-slider.swiper');
    if (!sliders.length) return;

    import('swiper/bundle').then(({ default: Swiper }) => {
        sliders.forEach(function (block) {
            const visibleCount = parseInt(block.dataset.visibleCount) || 6;

            new Swiper(block, {
                loop: true,
                freeMode: true,
                allowTouchMove: false,
                spaceBetween: 48,
                slidesPerView: 2,
                speed: 4000,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                    992: {
                        slidesPerView: Math.ceil(visibleCount / 2),
                        spaceBetween: 48,
                    },
                    1200: {
                        slidesPerView: visibleCount,
                        spaceBetween: 48,
                    },
                },
            });
        });
    });
}
